<template>
	<el-select
		v-model="value"
		class="select-box"
		ref="selectRef"
		filterable
		clearable
		:collapse-tags="collapseTags"
		:multiple-limit="10"
		:multiple="multiple"
		:placeholder="placeholder"
		@change="changeSelect"
		v-loadMore="loadMore"
		:remote="isRemote"
		:remote-method="remoteMethod"
		@clear="clear"
	>
		<el-option v-for="item in list" :key="item.id" :label="item.tag_name || item.tagName" :value="item.tag_name || item.tagName" />
		<div class="align-center bottom pt-8 pb-8 yx-color-text-secondary fz-12" v-if="isRemote">
			{{ noMore ? '到底了~' : '加载中' }}
		</div>
	</el-select>
</template>

<script>
import { tagsList } from '@/api/shopManage';
import { getTagList } from '@/api/tagManagement';
export default {
	name: 'SelectTag',
	props: {
		multiple: {
			type: Boolean,
			default: true,
		},
		selectValue: {
			type: [String, Array],
			default: () => [],
		},
		arr: {
			type: [Array],
			default: () => [],
		},
		returnArray: {
			type: Boolean,
			default: false,
		},
		collapseTags: {
			type: Boolean,
			default: false,
		},
		placeholder: {
			type: String,
			default: '请选择',
		},
		// 0商品标签 1达人标签 2素材标签
		type: {
			type: [Number, String],
			default: '0',
		},
	},
	watch: {
		selectValue: {
			handler: function (val) {
				setTimeout(() => {
					this.value = val;
					// //如果之前有标签则走选择标签的方法
					val.length && this.changeSelect(this.value);
				}, 400);
			},
			deep: true,
			immediate: true,
		},
	},
	data() {
		return {
			list: [],
			value: '',
			pageInfo: {
				page_index: 1,
				page_size: 100,
			},
			total: 0,
			noMore: true,
			isPadding: false,
			searchValue: '',
			isRemote: false,
		};
	},
	async created() {
		const { arr, multiple } = this;
		let tag_name = this.$route.query.tag_name || '';
		await this.getList('', 0, 'created');
		if (multiple) {
			if (arr.length) {
				if ([0, 1].includes(+this.type)) {
					this.value = this.list[0].tag_arr?.map(item => item.tag_name);
				}
				if ([2].includes(+this.type)) {
					this.value = this.list[0].tagList?.map(item => item.tagName);
				}
			} else {
				if (tag_name) (this.value = [tag_name]), this.changeSelect(this.value);
			}
		}
	},
	methods: {
		async getList(e = '', type = 0, value = '') {
			let api = {
				0: tagsList,
				1: tagsList,
				2: getTagList,
			};
			let params = {
				0: { ...this.pageInfo, tags_name: e, type: this.type },
				1: { ...this.pageInfo, tags_name: e, type: this.type },
				2: { pageIndex: this.pageInfo.page_index, pageSize: this.pageInfo.page_size, tagName: e, appType: 1 },
			};
			this.isPadding = true;
			try {
				const {
					code,
					data: { list = [], page = {} },
				} = await api[+this.type](params[+this.type]);
				if (code !== 0) return;
				this.loading = false;
				this.total = +page.item_total || +page.itemTotal;
				this.list = type ? this.list.concat(list) : list;
				if (value === 'created' && this.total > 100) this.isRemote = true;
			} finally {
				this.isPadding = false;
			}
		},
		loadMore() {
			let num = Math.ceil(this.total / this.pageInfo.page_size);
			if (num <= this.pageInfo.page_index) return (this.noMore = true);
			if (this.isPadding) return;
			this.noMore = false;
			this.pageInfo.page_index++;
			this.getList(this.searchValue, 1);
		},
		changeSelect(e) {
			const { multiple } = this;
			let res = '';
			if (multiple) {
				let idList = [];
				e.forEach(item => {
					if ([0, 1].includes(+this.type)) {
						idList = idList.concat(this.list.filter(ite => ite.tag_name === item));
					}
					if ([2].includes(+this.type)) {
						idList = idList.concat(this.list.filter(ite => ite.tagName === item));
					}
				});
				if (this.returnArray) {
					res = idList.map(k => k.id);
				} else {
					res = idList.map(k => k.id).join(',');
				}
				this.$emit('input', res);
			} else {
				let id = '';

				if (this.list.length) {
					if (this.returnArray) {
						if ([0, 1].includes(+this.type)) {
							id = this.list.filter(ite => ite.tag_name === e).map(k => k.id);
						}
						if ([2].includes(+this.type)) {
							id = this.list.filter(ite => ite.tagName === e).map(k => k.id);
						}
					} else {
						if ([0, 1].includes(+this.type)) {
							id = this.list
								.filter(ite => ite.tag_name === e)
								.map(k => k.id)
								.join(',');
						}
						if ([2].includes(+this.type)) {
							id = this.list
								.filter(ite => ite.tagName === e)
								.map(k => k.id)
								.join(',');
						}
					}
				}
				this.$emit('input', id);
			}
		},
		//远程搜索
		async remoteMethod(e) {
			this.$refs.selectRef.$refs.popper.$el.querySelector('.el-select-dropdown__wrap').scrollTo(0, 0);
			this.searchValue = e;
			this.pageInfo.page_index = 1;
			this.getList(e);
		},
		clear() {
			this.searchValue = '';
			this.pageInfo.page_index = 1;
			this.getList();
		},
		reset() {
			this.value = '';
		},
		resetPage() {
			this.pageInfo = {
				page_index: 1,
				page_size: 100,
			};
		},
	},
};
</script>
<style lang="less" scoped>
.bottom {
	border-top: 1px solid #ddd;
}
</style>
